export const DICEBEAR_AVATAR_STYLE = "notionists";
export const DICEBEAR_AVATAR_SIZE = 192;

/** Curated DiceBear seeds shown in the avatar picker. */
export const MORROW_DICEBEAR_AVATAR_SEEDS = [
  "atlas",
  "blair",
  "canyon",
  "dune",
  "ember",
  "fjord",
  "grove",
  "harbor",
  "iris",
  "jade",
  "kite",
  "linen",
  "mesa",
  "nova",
  "onyx",
  "prism",
  "quartz",
  "reef",
  "sage",
  "terra",
  "umber",
  "violet",
  "willow",
  "zephyr",
] as const;

export type MorrowDicebearAvatarSeed = (typeof MORROW_DICEBEAR_AVATAR_SEEDS)[number];

const SEED_SET = new Set<string>(MORROW_DICEBEAR_AVATAR_SEEDS);

export function isMorrowDicebearAvatarSeed(value: string): boolean {
  return SEED_SET.has(value.trim());
}

export function normalizeMorrowDicebearAvatarSeed(
  value: string | undefined | null,
): string | undefined {
  const trimmed = value?.trim();
  if (!trimmed || !SEED_SET.has(trimmed)) return undefined;
  return trimmed;
}

export function randomMorrowDicebearAvatarSeed(): MorrowDicebearAvatarSeed {
  const index = Math.floor(Math.random() * MORROW_DICEBEAR_AVATAR_SEEDS.length);
  return MORROW_DICEBEAR_AVATAR_SEEDS[index] ?? MORROW_DICEBEAR_AVATAR_SEEDS[0];
}

/** Stable DiceBear seed for someone who has not picked one yet. */
export function defaultMorrowDicebearAvatarSeed(seed: string): MorrowDicebearAvatarSeed {
  const normalized = seed.trim() || "member";
  let hash = 0;
  for (const character of normalized) {
    hash = (hash + character.charCodeAt(0)) | 0;
  }
  const index = Math.abs(hash) % MORROW_DICEBEAR_AVATAR_SEEDS.length;
  return MORROW_DICEBEAR_AVATAR_SEEDS[index] ?? MORROW_DICEBEAR_AVATAR_SEEDS[0];
}

export function dicebearPersonAvatarUrl(seed: string, size = DICEBEAR_AVATAR_SIZE): string {
  return `https://api.dicebear.com/9.x/${DICEBEAR_AVATAR_STYLE}/png?seed=${encodeURIComponent(seed.trim() || "member")}&size=${size}`;
}

export function resolvePersonAvatarUrl(
  name: string,
  options?: { readonly imageUrl?: string; readonly avatarSeed?: string },
): string {
  const portrait = options?.imageUrl?.trim();
  if (portrait) return portrait;
  const avatarSeed =
    normalizeMorrowDicebearAvatarSeed(options?.avatarSeed) ?? defaultMorrowDicebearAvatarSeed(name);
  return dicebearPersonAvatarUrl(avatarSeed);
}
